<template>
  <div class="required-device-message">
    <div class="uk-width-1-1">
      <span>
        <img :src="iconUrl" />
      </span>
      <span class="message">{{$t('deviceTypeMessage.someActivitiesRequire')}}</span>
      <span class="tool-tip-container">
        <span @mouseleave="resolveHover(false)" @mouseover="resolveHover(true)">
          <img :src="infoIcon" class="info-icon add-pointer" />
          <div class="tool-tip">
            <div class="tool-tip-message">{{$t('deviceTypeMessage.inviteYourClass')}}</div>
            <div class="watch-demo">
              <a @click="demoRedirect">{{$t('deviceTypeMessage.watchDemo')}}</a>
            </div>
          </div>
        </span>
      </span>
    </div>
    <hr />
  </div>
</template>

<script>
import iconUtil from '../../utils/icon-util'
import * as misc from '../../enums/misc'
import { ACTIVITY_INFO_DEMO } from '../../enums/static-urls'

export default {
  name: 'device-type-message',
  data() {
    return {
      hover: false,
      iconUrl: iconUtil.resolve(misc.DEVICE_ICON)
    }
  },
  methods: {
    resolveHover(hover) {
      this.hover = hover
    },
    demoRedirect() {
      window.open(ACTIVITY_INFO_DEMO, '_blank')
    }
  },
  computed: {
    infoIcon() {
      if (this.hover) {
        return iconUtil.resolve(misc.INFO_HOVER)
      } else {
        return iconUtil.resolve(misc.INFO)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/colours.scss';

.required-device-message {
  margin-top: -4px;

  hr {
    width: 100%;
  }

  .message {
    font-size: 16px;
    margin: 0 5px 0 5px;
  }
}

.tool-tip {
  visibility: hidden;
  width: 263px;
  min-height: 126px;
  top: 100%;
  left: 50%;
  margin-top: 20px;
  margin-left: -131.5px;
  box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.24);
  border: solid 1px $whisper-grey;
  background-color: $lightest-gray;
  color: $text;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
}

.tool-tip::after {
  content: ' ';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -10px;
  border-width: 5px;
  border-style: solid;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 20px solid $dark-grey;
  border-color: transparent transparent $lightest-gray transparent;
}

.tool-tip-container {
  position: relative;
  display: inline-block;
  text-align: center;
  font-size: 14px;
  &:hover {
    .tool-tip {
      visibility: visible;
    }
  }
}

.tool-tip-message {
  padding-top: 15px;
  padding-left: 24px;
  padding-right: 24px;
}

.watch-demo {
  font-weight: bold;
  margin-top: 15px;
}
</style>


